class Animate {

    constructor() {
        //this.root = $('.js-team-slider');

        this.init();
    }

    init() {
        // ************** main page **************
        // promo
        $(
            '.promo__heading,' +
            '.promo__info,' +
            '.promo__button-wrapper'
        ).addClass('_animated');

        // content side-title 
        $('.content-side__title')
            .addClass('wow fadeInUp')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','0s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        // content title 
        $('.content-center--title')
            .addClass('wow fadeInUp')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','0s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        // content desc 
        $('.content-center--desc')
            .addClass('wow fadeInUp')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','0s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        // content items-advantages 
        $('.items-advantages__item')
            .addClass('wow fadeInUp')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','0s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');
            
        // ingame
        $('.ingame__item')
            .addClass('wow fadeInUp')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','.2s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        $('.ingame__img')
            .addClass('wow fadeInUp')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','.2s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        $('.ingame__info')
            .addClass('wow fadeInUp')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','.4s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        $('.ingame-list')
            .addClass('wow fadeInUp')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','.4s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        // facts
        $('.facts__header')
            .addClass('wow fadeInUp')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','0s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        $('.facts__item:nth-of-type(1)')
            .addClass('wow fadeInLeft')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','0s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        $('.facts__item:nth-of-type(2)')
            .addClass('wow fadeInRight')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','0s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        $('.facts__item:nth-of-type(3)')
            .addClass('wow fadeInLeft')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','.25s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        $('.facts__item:nth-of-type(4)')
            .addClass('wow fadeInRight')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','.25s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        // facts v2
        $('.facts-v2-promo__header')
            .addClass('wow fadeInUp')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','.4s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        $('.facts-v2-promo__person:nth-of-type(1)')
            .addClass('wow fadeInLeft')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','1s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        $('.facts-v2-promo__person:nth-of-type(2)')
            .addClass('wow fadeInLeft')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','.8s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        $('.facts-v2-promo__person:nth-of-type(3)')
            .addClass('wow fadeInLeft')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','.6s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        $('.facts-v2-promo__person:nth-of-type(4)')
            .addClass('wow fadeInLeft')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','.4s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        // leadership
        $('.leadership__title')
            .addClass('wow fadeInUp')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','0s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        $('.leadership__text')
            .addClass('wow fadeInUp')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','.2s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        $('.leadership__award:nth-of-type(1)')
            .addClass('wow fadeIn')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','.4s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        $('.leadership__award:nth-of-type(2)')
            .addClass('wow fadeIn')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','.5s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        $('.leadership__award:nth-of-type(3)')
            .addClass('wow fadeIn')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','.6s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        $('.leadership__image')
            .addClass('wow jackInTheBox')
            .attr('data-wow-offset','400')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','.75s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        $('.leadership__text-footer')
            .addClass('wow fadeIn')
            .attr('data-wow-duration','.5s')
            .attr('data-wow-delay','.75s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');

        // projects
        $('.js-projects-slider').addClass('_animated').attr('data-tolerance','400').data('preRender',true);

        // team
        $('.js-team-slider').addClass('_animated').attr('data-tolerance','300').data('preRender',true);

        // vacancies
        $(
            '.vacancies__heading,'+
            '.vacancies__info,'+
            '.vacancies__request-title,'+
            '.vacancy-card-colored-block__title,'+
            '.vacancy-card-colored-block__text,'+
            '.vacancy-card-colored-block__footer'
        ).addClass('_animated');
        $('.vacancies__item').addClass('_animated').each((i, el)=> {
            $(el).css('transitionDelay', (0.4 + i * 0.2) + 's');
        });

        // articles
        $('.articles-item').addClass('_animated').each((i, el)=> {
            $(el).css('transitionDelay', (0.4 + i * 0.2) + 's');
        });

        // photos
        $('.photos__header,.photos__info').addClass('_animated');


        // ************** vacancy page **************
        // promo
        $(
            '.vacancy-promo__title,' +
            '.vacancy-promo__subtitle,' +
            '.vacancy-promo__desc,' +
            '.vacancy-promo__bg-hero img,' +
            '.vacancy-card__conditions li,' +
            '.vacancy-card__description-text,' +
            '.vacancy-card__option,' +
            '.vacancy-card__option-label,' +
            '.vacancy-card__option-text,' +
            '.vacancy-invitation__title,' +
            '.vacancy-invitation__button a,' +
            '.vacancy-invitation__share,' +
            '.vacancy-invitation__share .__tw'
        ).addClass('_animated');

        // ************** vacancy manager page **************
        // promo
        $(
            '.vacancy-citation,' +
            '.vacancy-description__shift-image,' +
            '.vacancy-description__cool,' +
            '.vacancy-description__wow,' +
            '.vacancy-manager-invitation__form .form'
        ).addClass('_animated');

        //sections
        $('.vacancy-description__heading')
            .addClass('wow fadeInUp')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','0s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');


        $('.vacancy-description__text')
            .addClass('wow fadeInUp')
            .attr('data-wow-duration','.75s')
            .attr('data-wow-delay','.4s')
            .css('animation-timing-function','cubic-bezier(.33,1.02,.58,1)');


        let onAnimate = function () {
            $('._animated:in-viewport').each((i,el)=> {
                // if ($(el).is('[data-tolerance]')) {
                //     $(el).filter(':in-viewport(' + $(el).data('tolerance') + ')').removeClass('_animated');
                // } else {
                //     $(el).filter(':in-viewport').removeClass('_animated');
                // }
                $(el).isInViewport({tolerance: $(el).data('tolerance') || 0}).each(()=> {
                    $(el).removeClass('_animated');
                    if ($(el).is('.js-projects-slider')) {
                        setTimeout(()=> {
                            $('.js-projects-slider').trigger('preRenderEnd');
                        }, 0);
                    }
                    else if ($(el).is('.js-team-slider')) {
                        setTimeout(()=> {
                            $('.js-team-slider').trigger('preRenderEnd');
                        }, 0);
                    }
                });
            });
        };
        onAnimate();
        $(window).on('scroll', onAnimate);
    }
}

let animate = (device.mobile() || device.tablet()) ? [] : new Animate();

export default animate;